// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Components Imports
import RevvEditorCheckboxField from "./RevvEditorCheckboxField";
import RevvEditorRadioField from "./RevvEditorRadioField";
import RevvEditorToogleField from "./RevvEditorToogleField";
import RevvEditorEmptyPlaceholder from "./RevvEditorEmptyPlaceholder";
// Actions Imports

// Internal Imports
import FormFieldCommand from "../../../commands/formFieldCommand";

function RevvEditorInputField({
  mode,
  fieldData,
  updateFormRowDataField,
  updateDynamicFieldsInDoc,
  updateDynamicFieldsInMasterDoc,
  updateEditorStateInSectionForClauseOptions,
  executeCommand,
  isDocInFillingState,
  docStage,
  placeholderText,
  docIsLocked,
  sectionId,
  inputFieldStyles,
}) {
  const {
    id,
    meta: {
      default: defaultValues,
      options,
      display,
      other_allowed: tempOtherAllowed,
    },
    filler_type: fillerType,
    field_meta: fieldMeta = {},
    type,
  } = fieldData;

  let fieldValue = Array.isArray(fieldData.value) ? fieldData.value : [];
  if (type === "RADIO" || type === "TOGGLE") {
    fieldValue = fieldData.value;
  }

  let isSharedDocumentPage = false;
  let isMagicLinkPage = false;

  let pathName = "";
  if (typeof window !== "undefined") {
    pathName = window.location.pathname;
  }
  if (pathName.includes("/shared/documents/")) {
    isSharedDocumentPage = true;
  }
  if (pathName.includes("/m/")) {
    isMagicLinkPage = true;
  }
  if (mode === "TEMPLATE") {
    fieldValue = defaultValues;
  }

  const _updateDynamicFieldsInDoc = (
    value,
    clauseOptionDetails,
    componentId,
  ) => {
    let sharingHash = "";

    let isMasterDocument = false;
    if (isSharedDocumentPage) {
      // eslint-disable-next-line prefer-destructuring
      sharingHash = pathName.split("/")[4];
    } else if (pathName.includes("/f/")) {
      isMasterDocument = true;
    }

    if (isMasterDocument) {
      const formFieldCommand = new FormFieldCommand({
        updateDynamicFieldsInMasterDoc,
        updateDynamicFieldsInDoc,
        updateEditorStateInSectionForClauseOptions,
        payload: {
          id,
          value,
          fieldValue: fieldValue || [],
          doctype: "MASTERDOC",
          type,
          clauseOptionDetails,
          componentId,
        },
      });
      executeCommand(formFieldCommand);
    } else if (isSharedDocumentPage) {
      if (sharingHash) {
        const formFieldCommand = new FormFieldCommand({
          updateDynamicFieldsInMasterDoc,
          updateDynamicFieldsInDoc,
          updateEditorStateInSectionForClauseOptions,
          payload: {
            id,
            value,
            isShared: true,
            sharingHash,
            fillerType,
            fieldValue: fieldValue || [],
            type,
            clauseOptionDetails,
            componentId,
          },
        });
        executeCommand(formFieldCommand);
      }
    } else {
      const formFieldCommand = new FormFieldCommand({
        updateDynamicFieldsInMasterDoc,
        updateDynamicFieldsInDoc,
        updateEditorStateInSectionForClauseOptions,
        payload: {
          id,
          value,
          isShared: false,
          sharingHash: null,
          fillerType,
          fieldValue: fieldValue || [],
          type,
          clauseOptionDetails,
          componentId,
        },
      });
      executeCommand(formFieldCommand);
    }
  };

  const _updateField = (value, fieldType) => {
    updateFormRowDataField(id, value);
    if (fieldType === "CHECKBOX") {
      _updateDynamicFieldsInDoc(value, value.join());
    } else if (fieldType === "RADIO" || fieldType === "TOGGLE") {
      _updateDynamicFieldsInDoc(value);
    }
  };

  let isDocInFinalStage = false;
  if (
    docStage === "SENT" ||
    docStage === "COMPLETED" ||
    docStage === "DECLINED" ||
    docStage === "APPROVED"
  ) {
    isDocInFinalStage = true;
  }

  // get the correct display settings(for both document and template)
  let fieldDisplay = { ...fieldMeta };
  let isOtherAllowed = fieldMeta ? fieldMeta.other_allowed : false;
  if (mode === "TEMPLATE") {
    fieldDisplay = { ...display };
    isOtherAllowed = tempOtherAllowed;
  }

  let isReadOnly = false;
  let className = "revveditor-checkbox-wrapper ";
  if (
    (!isDocInFillingState && isSharedDocumentPage) ||
    (fillerType === "SENDER" && isSharedDocumentPage) ||
    isDocInFinalStage ||
    isMagicLinkPage ||
    docIsLocked
  ) {
    isReadOnly = true;
    className += " read-only-checkbox ";
  }
  if (fieldDisplay.direction === "vertical") {
    className += " vertical-align ";
  }

  const isDisabled = mode === "TEMPLATE";
  if (type === "TOGGLE") {
    className += " toogle-type ";
    return (
      <RevvEditorToogleField
        id={id}
        isDisabled={mode === "TEMPLATE"}
        toogleValue={fieldValue}
        updateField={_updateField}
        isSharedDocumentPage={isSharedDocumentPage}
        isDocInFillingState={isDocInFillingState}
        isDocInFinalStage={isDocInFinalStage}
        isMagicLinkPage={isMagicLinkPage}
        isReadOnly={isReadOnly}
        className={className}
        sectionId={sectionId}
      />
    );
  }

  const checkboxSettingDisplay = { ...fieldDisplay };
  if (!fieldDisplay.show) {
    checkboxSettingDisplay.show = "all";
  }
  if (!fieldDisplay.direction) {
    checkboxSettingDisplay.direction = "horizontal";
  }

  let filteredOptions = [...options];

  if (
    !isDocInFillingState &&
    (mode === "DOCUMENT" || mode === "TEMPLATE_DOCUMENT") &&
    checkboxSettingDisplay.show === "selected"
  ) {
    if (type === "CHECKBOX") {
      filteredOptions = options.filter(option => fieldValue.includes(option));
    } else if (type === "RADIO") {
      filteredOptions = options.filter(option => fieldValue === option);
    }
  }

  if (type === "CHECKBOX") {
    const tempOptions = [...filteredOptions];

    if (!Array.isArray(fieldValue)) {
      fieldValue = [];
    }
    if (mode !== "TEMPLATE") {
      fieldValue.forEach((value, index) => {
        if (!tempOptions.includes(value)) {
          filteredOptions.splice(index, 0, value);
        }
      });
    }
  }

  // show the placeholder text if there is no default options
  if (
    filteredOptions.length === 0 &&
    checkboxSettingDisplay.show === "selected"
  ) {
    return (
      <RevvEditorEmptyPlaceholder
        display={checkboxSettingDisplay}
        placeholderText={placeholderText}
      />
    );
  }

  if (type === "CHECKBOX") {
    let tempFilteredOptions = [...filteredOptions];
    if (isOtherAllowed) {
      if (mode === "TEMPLATE") {
        tempFilteredOptions.push("Other ");
      } else {
        tempFilteredOptions = tempFilteredOptions.filter(
          option => !option.includes("Other : "),
        );
        const otherOption = fieldValue
          ? fieldValue.find(val => val.includes("Other : "))
          : null;

        if (otherOption) {
          if (otherOption.length > 8) {
            tempFilteredOptions.push(otherOption);
          } else {
            tempFilteredOptions.push("Other ");
          }
        } else if (checkboxSettingDisplay.show === "all") {
          tempFilteredOptions.push("Other ");
        }
      }
    }
    return (
      <RevvEditorCheckboxField
        id={id}
        isDisabled={isDisabled}
        values={fieldValue}
        updateField={_updateField}
        filteredOptions={tempFilteredOptions}
        options={options}
        display={checkboxSettingDisplay}
        isSharedDocumentPage={isSharedDocumentPage}
        isDocInFillingState={isDocInFillingState}
        isDocInFinalStage={isDocInFinalStage}
        isMagicLinkPage={isMagicLinkPage}
        isReadOnly={isReadOnly}
        className={className}
        sectionId={sectionId}
        inputFieldStyles={inputFieldStyles}
      />
    );
  }

  if (type === "RADIO") {
    if (isOtherAllowed) {
      if (mode === "TEMPLATE") {
        filteredOptions.push("Other ");
      } else {
        let otherOptionValue = null;
        if (
          fieldValue &&
          fieldValue.includes("Other : ") &&
          fieldValue.length > 8
        ) {
          otherOptionValue = fieldValue;
        } else {
          otherOptionValue = "Other ";
        }
        if (otherOptionValue) {
          filteredOptions.push(otherOptionValue);
        }
      }
    }
    return (
      <RevvEditorRadioField
        id={id}
        isDisabled={isDisabled}
        fieldValue={fieldValue}
        display={checkboxSettingDisplay}
        isSharedDocumentPage={isSharedDocumentPage}
        isDocInFillingState={isDocInFillingState}
        isMagicLinkPage={isMagicLinkPage}
        isDocInFinalStage={isDocInFinalStage}
        updateField={_updateField}
        options={filteredOptions}
        isReadOnly={isReadOnly}
        className={className}
        sectionId={sectionId}
        inputFieldStyles={inputFieldStyles}
      />
    );
  }

  return null;
}

const mapStateToProps = (state, props) => {
  const {
    document: { scope: { write, fill } = {}, isLocked, stage, docType } = {},
    docRecipientList,
    acceptorsList,
  } = state.DocumentStore;
  const { recipientType } = state.SharedDocument;
  const CURRENT_USER = props.currentUser;
  // For internal user
  const currentUserIsFiller = docRecipientList.some(
    item =>
      item.user &&
      item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
      item.recipient_type === "FILLER",
  );
  const currentAcceptorIsFiller = acceptorsList.some(
    item =>
      item.user &&
      item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
      item.recipient_type === "FILLER",
  );

  let lockedInStage = true;
  if (
    docType === "master_form" &&
    (recipientType === "" || recipientType === null)
  ) {
    lockedInStage = true;
  } else if (
    stage === "DRAFT" ||
    (stage === "SENT_FOR_FILLING" &&
      (recipientType === "FILLER" ||
        currentUserIsFiller ||
        currentAcceptorIsFiller))
  ) {
    lockedInStage = false;
  }

  let OwnerFiller = false;
  const OwnerFillerCheck =
    stage === "SENT_FOR_FILLING" &&
    docRecipientList &&
    docRecipientList.some(
      item =>
        item.user &&
        item.user.id === (CURRENT_USER && CURRENT_USER.id) &&
        item.recipient_type === "FILLER",
    );
  if (
    OwnerFillerCheck &&
    props.fieldData &&
    props.fieldData.filler_type !== "RECIPIENT"
  ) {
    OwnerFiller = true;
  }

  return {
    docIsLocked: (isLocked && !(write || fill)) || lockedInStage || OwnerFiller,
  };
};

export default connect(mapStateToProps, null)(RevvEditorInputField);
